(function () {

    "use strict";

    angular
        .module('harriApp')
        .controller("ReceiptRulesModalController", ReceiptRulesModalController);

    ReceiptRulesModalController.$inject = ['$scope'];

    function ReceiptRulesModalController($scope) {

        var self = this;

        self.close = function () {
            $scope.$hide();
        };

    }
})();
